import React from 'react';
import { Card, Typography, Box } from '@mui/material';
import Iconify from 'src/components/Iconify';

const ListCard = ({ origin, destination, equipmentType, weight, length }) => {
    return (
        <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingLeft: 10, paddingRight: 10, paddingTop: 10, paddingBottom: 10, borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}>
            <Box style={{
                height: 40,
                width: 40,
                borderRadius: 10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: '2px solid #010f58'
            }}>
                <Iconify icon={'iconoir:delivery-truck'} sx={{ flex: 1, fontSize: 23, color: process.env.REACT_APP_PRIMARY }} />
            </Box>

            <Box style={{ flex: 1, marginLeft: 8 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", marginBottom: -9 }}>
                    <div style={{
                        height: 5,
                        width: 5,
                        borderRadius: 100,
                        backgroundColor: "white",
                        border: "1.8px solid #010f58",
                        marginRight: 5,

                    }}></div>
                    <p style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '135px', // Adjust this width as needed
                        fontSize: 10
                    }}>
                        {origin}
                    </p>
                </div>
                <div>
                    <Iconify icon="mingcute:arrow-down-line" style={{ fontSize: 12, marginLeft: -3.5, color: process.env.REACT_APP_PRIMARY }} />
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", marginTop: -10 }}>
                    <div style={{
                        height: 5,
                        width: 5,
                        borderRadius: 100,
                        backgroundColor: "white",
                        border: "1.8px solid #010f58",
                        marginRight: 5,

                    }}></div>
                    <p style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '135px', // Adjust this width as needed
                        fontSize: 10,
                    }}
                    >{destination}</p>
                </div>
            </Box>

            <Box sx={{ width: "70px" }}>
                <p style={{
                    fontSize: 9,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '70px',
                    // backgroundColor:'red'
                }}>{equipmentType}</p>

                <p style={{
                    fontSize: 9,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '70px',
                }}>{weight} | {length}</p>

            </Box>

        </Box>
    );
};

export default ListCard;
